var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ToggleInput',{staticClass:"ui-ToggleControl text-midGrey ml-base",attrs:{"value":_vm.value,"label":_vm.label,"labelFirst":true,"data-test":"toggler"},on:{"input":function($event){return _vm.$emit('toggled', !_vm.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }